 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import LOVE_1 from '@/components/love_1'
 import BOOKDESCRIPTION from '@/components/book-description'
 import UNTITLED from '@/components/untitled'
 import TITLEPAGE from '@/components/title-page'
 import COPYRIGHT from '@/components/copyright'
 import CONTENTS from '@/components/contents'
 import INTRODUCTIONTHEFIRESOFINSPIRATION from '@/components/introduction-the-fires-of-inspiration'
 import SPLENDIDMIRAGETHESEEKERSTALE from '@/components/splendid-mirage-the-seekers-tale'
 import THEFIRESERMON from '@/components/the-fire-sermon'
 import ONEHITWEBSTER from '@/components/one-hit-webster'
 import THEDOOR from '@/components/the-door'
 import THEBURRENOFMARS from '@/components/the-burren-of-mars'
 import WHITEFEATHER from '@/components/white-feather'
 import INTOTHEVALLEY from '@/components/into-the-valley'
 import THELASTWAKINGPRINCESS from '@/components/the-last-waking-princess'
 import THEFIRSTPROBLEM from '@/components/the-first-problem'
 import MIJACULPO from '@/components/mi-jaculpo'
 import ONEFORHUNGERTWOFORJOY from '@/components/one-for-hunger-two-for-joy'
 import THEHUNTERANDTHEHUNTED from '@/components/the-hunter-and-the-hunted'
 import TAKEMEFORARIDE from '@/components/take-me-for-a-ride'
 import HYDEPARK from '@/components/hyde-park'
 import BOWDRILL from '@/components/bow-drill'
 import DREAMGIRL from '@/components/dream-girl'
 import WHITESAILSANDSTORMYSEAS from '@/components/white-sails-and-stormy-seas'
 import CHECKYESORNO from '@/components/check-yes-or-no'
 import DONTIGNOREIT from '@/components/dont-ignore-it'
 import LOVE_2 from '@/components/love_2'
 import ADDITIONALCOPYRIGHTINFORMATION from '@/components/additional-copyright-information'
 import ABOUTTHEEDITOR from '@/components/about-the-editor'
 import IFYOULIKED from '@/components/if-you-liked'
 import OTHERWORDFIREPRESSTITLESEDITEDBYLISAMANGUM from '@/components/other-wordfire-press-titles-edited-by-lisa-mangum'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/introduction-the-fires-of-inspiration",
 			"name" : "introduction-the-fires-of-inspiration",
 			"component" : INTRODUCTIONTHEFIRESOFINSPIRATION
 		},
 		{
 			"path" : "/splendid-mirage-the-seekers-tale",
 			"name" : "splendid-mirage-the-seekers-tale",
 			"component" : SPLENDIDMIRAGETHESEEKERSTALE
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js